// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2nA5z","row":"ProcedureTreatmentSummary_row__2TYG0"};